import isNil from 'lodash/isNil';
import { useQueryStates } from 'nuqs';
import { SEARCH_PARAMS } from '@/routes/search-params';
import { ALL_ECONOMIC_UNITS_ITEM } from '@/sections/StatusQuoAnalysis/NavigationSelectors/Hooks/useEconomicUnitsSelector';
import { useStatusQuoSelectionStorage } from '@/sections/StatusQuoAnalysis/useStatusQuoSelectionStorage';

export const RedirectToStatusQuoFirstEconomicUnit = () => {
  const [queryParams, setQueryParams] = useQueryStates(SEARCH_PARAMS.statusQuoAnalysis.economicUnits);

  const { economicUnitIds: storedEconomicUnitIds } = useStatusQuoSelectionStorage();

  if (queryParams.economicUnitIds?.length === 1 && queryParams.economicUnitIds[0] === ALL_ECONOMIC_UNITS_ITEM().value) {
    return null;
  }

  if (
    !isNil(storedEconomicUnitIds) &&
    storedEconomicUnitIds.length > 0 &&
    (isNil(queryParams.economicUnitIds) || queryParams.economicUnitIds.length === 0)
  ) {
    void setQueryParams({ economicUnitIds: storedEconomicUnitIds });
    return null;
  }

  if (isNil(queryParams.economicUnitIds) || queryParams.economicUnitIds.length === 0) {
    void setQueryParams({ economicUnitIds: [ALL_ECONOMIC_UNITS_ITEM().value] });
    return null;
  }

  return null;
};
